import { AnyComponent } from 'preact'
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import { RoleList } from '@insided/deprecated-control/UserOverview/Columns'
import EditRole from './EditRole'

const getBulkActions = (roles: RoleList, source: string): Array<AnyComponent<BulkActionComponentProps>> => [
  props => <EditRole {...props} customRoles={roles.customRoles} source={source} />
]

export default getBulkActions
